<script lang="ts">
  import { onDestroy } from "svelte"

  let {
    threshold = 0,
    horizontal = false,
    elementScroll = null,
    hasMore = true,
    onloadmore
  } = $props()

  let isLoadMore = false
  let component

  $effect(() => {
    if (component || elementScroll) {
      const element = elementScroll ? elementScroll : component.parentNode

      element.addEventListener("scroll", onScroll)
      element.addEventListener("resize", onScroll)
    }
  })

  const onScroll = (e: MouseEvent) => {
    const element = e.target

    const offset = horizontal
      ? e.target.scrollWidth - e.target.clientWidth - e.target.scrollLeft
      : e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop

    if (offset <= threshold) {
      if (!isLoadMore && hasMore) {
        onloadmore()
      }
      isLoadMore = true
    } else {
      isLoadMore = false
    }
  }

  onDestroy(() => {
    if (component || elementScroll) {
      const element = elementScroll ? elementScroll : component.parentNode

      element?.removeEventListener("scroll", onScroll)
      element?.removeEventListener("resize", onScroll)
    }
  })
</script>

<div bind:this={component} style="width:0px"></div>
